// extracted by mini-css-extract-plugin
module.exports = {"container":"matrixOrder_container__2D4-1","matrixTableWrapper":"matrixOrder_matrixTableWrapper__3DH9f","matrixOrderSummary":"matrixOrder_matrixOrderSummary__21BuE"};